export default __webpack_public_path__ + "static/media/1a.174385ec.jpg";